export default __webpack_public_path__ + "static/media/icon-pagamento-boletos.2fd1ce36.svg";